import { render, staticRenderFns } from "./BrowseColumnSelectJsonProperty.vue?vue&type=template&id=70e483c4&scoped=true"
import script from "./BrowseColumnSelectJsonProperty.vue?vue&type=script&lang=ts"
export * from "./BrowseColumnSelectJsonProperty.vue?vue&type=script&lang=ts"
import style0 from "./BrowseColumnSelectJsonProperty.vue?vue&type=style&index=0&id=70e483c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e483c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70e483c4')) {
      api.createRecord('70e483c4', component.options)
    } else {
      api.reload('70e483c4', component.options)
    }
    module.hot.accept("./BrowseColumnSelectJsonProperty.vue?vue&type=template&id=70e483c4&scoped=true", function () {
      api.rerender('70e483c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/models/BrowseColumnSelectJsonProperty.vue"
export default component.exports